import { EaseChatSDK, EaseChatClient } from '@/IM/initwebsdk'
import { setMessageKey, createMessage } from '@/utils/handleSomeData'
import { parseAsChinaTime } from '@/utils/chinaTime'
import { sendMsg, recallMessage, getStateByMessageId, revocationMsg, getHistoryMessageCustom } from '@/api/custom'
import { getSysNoticeList } from '@/api/systemNotice'
import _ from 'lodash'
// import { ref, toRaw } from 'vue';
import { messageType } from '@/constant'
import { usePlayRing } from '@/hooks'
import { ElMessage } from 'element-plus'
import {
  MAX_CACHED_MESSAGES_PER_CONVERSATION,
  MAX_CACHED_MESSAGE_CONVERSATIONS,
} from '@/constant/imPerformance'
const { ALL_MESSAGE_TYPE } = messageType

const getMessageId = (message) =>
  message?.id ?? message?.mid ?? message?.messageId ?? message?.msgId ?? null

const mergeUniqueMessages = (messages) => {
  const mergedMessages = []
  const messageIndexes = new Map()

  messages.forEach((message) => {
    const messageId = getMessageId(message)
    if (messageId === null) {
      mergedMessages.push(message)
      return
    }

    const normalizedId = String(messageId)
    const existingIndex = messageIndexes.get(normalizedId)
    if (existingIndex === undefined) {
      messageIndexes.set(normalizedId, mergedMessages.length)
      mergedMessages.push(message)
      return
    }

    mergedMessages[existingIndex] = {
      ...mergedMessages[existingIndex],
      ...message,
    }
  })

  return mergedMessages
}

const touchMessageConversation = (state, conversationKey) => {
  state.messageListAccessTimes[conversationKey] = Date.now()
}

const pruneInactiveMessageConversations = (state, activeConversationKey) => {
  const conversationKeys = Object.keys(state.messageList)
  if (conversationKeys.length <= MAX_CACHED_MESSAGE_CONVERSATIONS) return

  const protectedKeys = new Set(
    [state.currentChatId, activeConversationKey].filter(Boolean).map((key) => String(key)),
  )
  const removableKeys = conversationKeys
    .filter((key) => !protectedKeys.has(String(key)))
    .sort((left, right) => {
      return (state.messageListAccessTimes[left] || 0) - (state.messageListAccessTimes[right] || 0)
    })

  let removeCount = conversationKeys.length - MAX_CACHED_MESSAGE_CONVERSATIONS
  for (const key of removableKeys) {
    if (removeCount <= 0) break
    delete state.messageList[key]
    delete state.messageListAccessTimes[key]
    removeCount--
  }
}

const Message = {
  state: {
    messageList: {},
    messageListAccessTimes: {},
    unReadMsgIds: [],
    businessMsgState: {}, //全局保存业务消息的状态,在消息列表柑橘此状态显示不同视图 key:消息的id  value：业务消息的状态对象
    currentChatId: '', //当前会话的对方环信id
    currentChatType: '', //当前会话的类型
    systemNoticeUnreadNum: 0, //系统通知未读条数
    systemNoticeListData: {}, //系统通知列表数据
    messageExt: '', //发送消息时需要携带的扩展参数
  },
  mutations: {
    // 更改 发送消息时需要携带的扩展参数
    UPDATE_messageExt(state, str) {
      // console.log("%c Line:25 🥖 UPDATE_messageExtstr", "color:#b03734", str);
      state.messageExt = str
    },
    // 更改系统通知未读条数
    UPDATE_systemNoticeUnreadNum(state, num) {
      state.systemNoticeUnreadNum = num
    },
    // 更改系统通知列表数据
    UPDATE_systemNoticeListData(state, list) {
      state.systemNoticeListData = list
    },
    // 更改当前会话id
    UPDATE_CURRENT_CHAT_ID(state, chatId) {
      state.currentChatId = chatId
    },
    // 更改当前会话的类型
    UPDATE_CURRENT_CHAT_TYPE(state, chatType) {
      state.currentChatType = chatType
    },
    // 清空当前会话消息
    DELETE_ALL_MESSAGE_BY_ID(state, conversationKey) {
      if (conversationKey in state.messageList) delete state.messageList[conversationKey]
      delete state.messageListAccessTimes[conversationKey]
    },

    // 更新业务消息状态
    UPDATE_BBUSINESS_MSG_STATE(state, stateMap) {
      state.businessMsgState[stateMap.messageId] = { ...stateMap }
    },
    UNDATE_UNREAD_IDS: (state, ids) => {
      state.unReadMsgIds = ids
      localStorage.setItem('unreadMsgIds', JSON.stringify(ids))
    },
    DELETE_UNREAD_ID_ONE: (state, id) => {
      // 删除一个未读id
      let index = state.unReadMsgIds.indexOf(id)
      if (index > -1) {
        state.unReadMsgIds.splice(index, 1)
        localStorage.setItem('unreadMsgIds', JSON.stringify(state.unReadMsgIds))
      }
    },
    UPDATE_MESSAGE_LIST: (state, msgBody) => {
      const listKey = setMessageKey(msgBody)
      const currentMessages = state.messageList[listKey] || []
      const messageId = getMessageId(msgBody)
      const existingIndex =
        messageId === null
          ? -1
          : currentMessages.findIndex((message) => String(getMessageId(message)) === String(messageId))

      if (existingIndex >= 0) {
        currentMessages.splice(existingIndex, 1, {
          ...currentMessages[existingIndex],
          ...msgBody,
        })
      } else {
        currentMessages.push(msgBody)
      }

      if (currentMessages.length > MAX_CACHED_MESSAGES_PER_CONVERSATION) {
        currentMessages.splice(0, currentMessages.length - MAX_CACHED_MESSAGES_PER_CONVERSATION)
      }

      state.messageList[listKey] = currentMessages
      touchMessageConversation(state, listKey)
      pruneInactiveMessageConversations(state, listKey)
    },
    UPDATE_HISTORY_MESSAGE: (state, payload) => {
      const { listKey, historyMessage } = payload
      const currentMessages = state.messageList[listKey] || []
      const incomingHistory = Array.isArray(historyMessage) ? historyMessage : []
      const mergedMessages = mergeUniqueMessages([...incomingHistory, ...currentMessages])
      state.messageList[listKey] = mergedMessages.slice(-MAX_CACHED_MESSAGES_PER_CONVERSATION)
      touchMessageConversation(state, listKey)
      pruneInactiveMessageConversations(state, listKey)
    },
    //清除某条会话消息
    CLEAR_SOMEONE_MESSAGE: (state, payload) => {
      state.messageList[payload] = []
      touchMessageConversation(state, payload)
    },
    //撤回删除消息 已读消息
    CHANGE_MESSAGE_BODAY: (state, payload) => {
      const { type, key, mid } = payload
      if (type === 'recall') {
        if (state.messageList[key]) {
          const res = _.find(state.messageList[key], (o) => o.id === mid)
          if (res) res.isRecall = true
        }
      }
      if (type === 'deleteMsg') {
        if (state.messageList[key]) {
          const sourceData = state.messageList[key]
          const index = _.findIndex(state.messageList[key], (o) => o.id === mid)
          if (index >= 0) {
            sourceData.splice(index, 1)
            state.messageList[key] = _.assign([], sourceData)
          }
        }
      }
      if (type === 'read') {
        // 未读消息正文可能已经被缓存淘汰，回执仍需正常清理未读状态
        const unreadIndex = state.unReadMsgIds.indexOf(mid)
        if (unreadIndex > -1) {
          state.unReadMsgIds.splice(unreadIndex, 1)
          localStorage.setItem('unreadMsgIds', JSON.stringify(state.unReadMsgIds))
        }
      }
      if (type === 'converReaded') {
        if (state.messageList[key]) {
          const sourceData = state.messageList[key]
          if (sourceData && sourceData.length) {
            const conversationMessageIds = new Set(sourceData.map((message) => message.id))
            state.unReadMsgIds = state.unReadMsgIds.filter((id) => !conversationMessageIds.has(id))
            localStorage.setItem('unreadMsgIds', JSON.stringify(state.unReadMsgIds))
          }
        }
      }
    },
  },
  actions: {
    // 获取系统消息未读条数
    getSysNotice: async (
      { commit },
      params = {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        // sendType: 'SB1000'
      },
    ) => {
      // // 判断角色
      // const temp = localStorage.getItem('customUserInfo')
      //   if (temp) {
      //     const userInfo = JSON.parse(temp)
      //     if(userInfo&&userInfo.roles){
      //       const roleArr = Array.from(userInfo.roles,({roleKey})=>roleKey)
      //       if(roleArr.includes('youxizhishou')){
      //         // 直收商
      //       }
      //       if(roleArr.includes('salesCustomer')){
      //         // 客服
      //         params.sendType = ''
      //         params.sendTypeName = 'saleOrder'
      //       }
      //     }
      //   }
      // 客服
      // params.sendType = ''
      // params.sendTypeName = 'saleOrder'
      // try {
      //     let res = await getSysNoticeList(params)
      //     commit('UPDATE_systemNoticeUnreadNum', res.params?.wdCount || 0)
      //     commit('UPDATE_systemNoticeListData', res)
      //     return res
      // } catch (error) {
      //     console.log("%c Line:181 🍬 error", "color:#93c0a4", error);
      // }
    },
    // 获取业务消息状态
    getStateByMessageIdFn: async ({ commit }, msgIds) => {
      let res = await getStateByMessageId({
        messageIds: msgIds.join(','),
      })
      if (res.data) {
        res.data.forEach((r) => {
          commit('UPDATE_BBUSINESS_MSG_STATE', r, r.messageId)
        })
      }

      return res.data
    },
    // 获取本地未读消息IDs
    getLocalUnreadMsgIds: ({ dispatch, commit }, params) => {
      let tempUnreadMsgIds = localStorage.getItem('unreadMsgIds')
      let arr = []
      if (tempUnreadMsgIds && JSON.parse(tempUnreadMsgIds).length) {
        arr = JSON.parse(tempUnreadMsgIds)
      } else {
        localStorage.setItem('unreadMsgIds', JSON.stringify(arr))
      }
      commit('UNDATE_UNREAD_IDS', arr)
    },
    // 添加消息到未读IDs
    addMsgToUnreadIds: ({ dispatch, commit, state }, params) => {
      let arr = JSON.parse(JSON.stringify(state.unReadMsgIds))
      if (arr.indexOf(params) == -1) arr.push(params)
      commit('UNDATE_UNREAD_IDS', arr)
    },
    //添加新消息
    createNewMessage: ({ dispatch, commit }, params) => {
      const { isOpenPlayRing, playRing } = usePlayRing()
      const key = setMessageKey(params)
      commit('UPDATE_MESSAGE_LIST', params)
      // console.log("%c Line:230 🍻 收到信息params", "color:#ffdd4d", params);
      // if(params.type=='custom'&&(params.customEvent=='b_backlist'||params.customEvent=='b_backorder')){
      //   dispatch('getStateByMessageIdFn',[params.id])
      // }
      //目前根据全局配置进行新消息声音提示，后续计划根据会话级别可进行设置是否声音提示，比如设定免打扰。
      if (isOpenPlayRing.value) {
        const loginUserId = EaseChatClient.user
        if (loginUserId != params.from) {
          playRing()
          if (params.type == 'txt' && params.msg && params.msg.indexOf('@') > -1) {
            if (window.Notification && Notification.permission !== 'denied') {
              Notification.requestPermission(function (status) {
                var n = new Notification('您有新消息', {
                  body: '新消息：' + params.msg,
                })
              })
            }
          }
        }
      }
      return dispatch('gatherConversation', { key, message: params })
    },
    // //获取历史消息 业务消息更新时调用
    // getHistoryMessageForBussiness: async ({ dispatch, commit,state }, params) => {
    //   console.log("%c Line:187 🧀业务消息更新时调用获取历史消息 params", "color:#42b983", params);
    //     const { id, chatType } = params
    //     if(id in state.messageList){
    //       return new Promise((resolve, reject) => {
    //           const options = {
    //               targetId: id,
    //               pageSize: 10,
    //               cursor: state.messageList[id][state.messageList[id].length-1].id,
    //               chatType: chatType,
    //               searchDirection: 'down'
    //           }
    //           EaseChatClient.getHistoryMessages(options)
    //             .then((res) => {
    //                 const { cursor, messages } = res
    //                 messages.length > 0 &&
    //                     messages.forEach((item) => {
    //                         item.read = true
    //                         if(state.unReadMsgIds.indexOf(item.id)>-1){
    //                           item.read = false
    //                         }
    //                         if(item.id){
    //                           // 创建消息
    //                           dispatch('createNewMessage', item)
    //                         }

    //                         if(item.type=='custom'&&item.customEvent=='b_backlist'){
    //                           dispatch('getStateByMessageIdFn',item.id)
    //                         }
    //                     })
    //                 resolve({ messages, cursor })
    //                 //提示会话列表更新
    //                 dispatch('gatherConversation', id)
    //             })
    //             .catch((error) => {
    //                 reject(error)
    //             })
    //       })
    //     }else{
    //       dispatch('getHistoryMessage',{...params,cursor:-1})
    //     }

    // },
    // 发送已读回执
    sendReaded: ({ commit }, msg) => {
      let option = {
        type: 'read', // 消息是否已读。
        chatType: 'singleChat', // 会话类型，这里为单聊。
        to: msg.from, // 消息接收方的用户 ID。
        id: msg.id, // 需要发送已读回执的消息 ID。
      }
      let message = EaseChatSDK.message.create(option)
      EaseChatClient.send(message)
    },
    //获取历史消息 聊天窗口 查看更多消息
    getHistoryMessage: async ({ dispatch, commit, state }, params) => {
      // console.log("%c Line:187 🧀获取历史消息 params", "color:#42b983", params);
      const { id, chatType, cursor, flag } = params
      const loginUserId = EaseChatClient.user
      return new Promise((resolve, reject) => {
        const options = {
          targetId: id,
          pageSize: 10,
          cursor: cursor,
          chatType: chatType,
          searchDirection: 'up',
        }
        // getHistoryMessageCustom(options)
        let sessionId = id
        if (chatType == 'singleChat') {
          // 单聊
          if (loginUserId > id) {
            sessionId = loginUserId + id
          } else {
            sessionId = id + loginUserId
          }
        }
        getHistoryMessageCustom(sessionId, cursor, 1, 10)
          // EaseChatClient.getHistoryMessages(options)
          .then((res) => {
            // console.log("%c Line:331 🍐 res", "color:#4fff4B", res);
            const { rows } = res
            let businessMsg = []
            let busIds = []
            const messages = []
            rows.length > 0 &&
              rows.forEach((item) => {
                // 处理数据格式，组装为环信历史消息格式
                const msgExt = {
                  fromUserInfo: {
                    avatar: item.fromUserAvatar,
                    nickName: item.fromUserName,
                  },
                }
                let msgObj = {
                  id: item.messageId,
                  yuduMsgId: item.id,
                  chatType: item.toGroup ? 'groupChat' : 'singleChat',
                  to: item.toGroup ? item.toGroup : item.toUser,
                  from: item.formUser,
                  ext: {
                    msgExt: JSON.stringify(msgExt),
                    businessState: item.businessState,
                    businessId: item.businessId,
                    businessFunction: item.businessFunction,
                  },
                  time: parseAsChinaTime(item.createTime),
                  onlineState: 3,
                }
                if (item.type == 'text') {
                  // 环信文本消息
                  msgObj.type = 'txt'
                  msgObj.msg = item.content
                  msgObj.msgConfig = {}
                } else {
                  // 环信自定义消息
                  msgObj.type = 'custom'
                  msgObj.customEvent = item.customType
                  msgObj.params = {}
                  msgObj.customExts = {
                    content: item.content,
                  }
                }
                msgObj.read = true
                if (state.unReadMsgIds.indexOf(msgObj.id) > -1) {
                  msgObj.read = false
                }
                messages.push(msgObj)
                if ((item.businessFunction === 'card_action' || item.customType === 'settlementPushBuyer') && item.messageId) {
                  busIds.push(item.messageId)
                }
                // if(item.type=='custom'&&(item.customEvent=='b_backlist'||item.customEvent=='b_backorder')){
                //   businessMsg.push(item)
                //   busIds.push(item.id)
                // }

                if (chatType == 'singleChat' && loginUserId != msgObj.from) {
                  dispatch('sendReaded', msgObj)
                }
              })
            if (busIds.length) dispatch('getStateByMessageIdFn', busIds)
            resolve({ messages })
            if (flag == 'createMyMsg') {
              businessMsg.length > 0 && dispatch('createNewMessage', businessMsg[0])
            } else {
              commit('UPDATE_HISTORY_MESSAGE', {
                listKey: id,
                historyMessage: messages,
              })
            }
            //提示会话列表更新
            dispatch('gatherConversation', id)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    //发送展示类型消息
    sendShowTypeMessage: async ({ dispatch, commit, state, rootState }, params) => {
      return new Promise((resolve, reject) => {
        //console.log('%c Line:126 🍖 params', 'color:#ed9ec7', params)
        //主要作用为创建消息Options中附件会有上传失败的回调函数。
        //传入errorCallback，让附件类型消息在上传失败时调用reject抛出error

        // params
        let params2 = {}
        let msgData = {}
        if (params.msgType == 'txt') {
          if (params.msgOptions.msg && /^订单编号/.test(params.msgOptions.msg)) {
            // 发送的是订单
            msgData = {
              fromUser: EaseChatClient.user,
              content: params.msgOptions.msg,
              senType: 'order',
            }
            params.msgOptions.customExts = params.msgOptions.msg
            params.msgOptions.customEvent = msgData.senType
            params = {
              msgType: 'custom',
              msgOptions: params.msgOptions,
            }
          } else {
            // 普通文本
            msgData = {
              fromUser: EaseChatClient.user,
              content: params.msgOptions.msg,
              senType: 'text',
            }
          }
        } else if (params.msgType == 'img') {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.imgUrl,
            senType: 'image',
          }
        } else if (params.msgType == 'sticker') {
          // 表情包：按 URL 直接发送，前端按小尺寸渲染（区别于普通图片）
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.imgUrl,
            senType: 'sticker',
          }
          params.msgOptions.customExts = params.msgOptions.imgUrl
          params.msgOptions.customEvent = 'sticker'
          params = {
            msgType: 'custom',
            msgOptions: params.msgOptions,
          }
        } else if (params.msgType == 'audio') {
          let content = {
            url: params.msgOptions.file.url,
            length: params.msgOptions.length,
          }
          msgData = {
            fromUser: EaseChatClient.user,
            content: JSON.stringify(content),
            senType: 'audio',
          }
        } else if (params.msgType == 'video') {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.url,
            senType: 'video',
          }
          params.msgOptions.customExts = params.msgOptions.url
          params.msgOptions.customEvent = msgData.senType
          params = {
            msgType: 'custom',
            msgOptions: params.msgOptions,
          }
        } else if (params.msgType == 'goods') {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.goods,
            senType: 'goods',
          }
          params.msgOptions.customExts = params.msgOptions.goods
          params.msgOptions.customEvent = msgData.senType
          params = {
            msgType: 'custom',
            msgOptions: params.msgOptions,
          }
        } else {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.content,
            senType: params.msgType,
          }
          params.msgOptions.customExts = params.msgOptions.content
          params.msgOptions.customEvent = msgData.senType
          params = {
            msgType: 'custom',
            msgOptions: params.msgOptions,
          }
        }
        if (params.msgOptions.chatType == 'groupChat') {
          // 群聊
          msgData.toGroup = params.msgOptions.id
          // state
          //console.log("%c Line:211 🥝 Groups", "color:#e41a6a", Groups.state.groupsInfos);
          // if(Groups.state.groupsInfos[params.msgOptions.id]){
          //   let persons = Groups.state.groupsInfos[params.msgOptions.id]
          // }
        } else if (params.msgOptions.chatType == 'singleChat') {
          // 单聊
          msgData.toUser = params.msgOptions.id
        }

        const errorCallback = (error) => {
          reject(error)
        }

        const options = createMessage.createOptions(params, errorCallback)
        const msg = EaseChatSDK.message.create(options)
        // state.messageExt
        const msgExt = {
          fromUserInfo: {
            avatar: rootState.loginUserInfo.avatarurl,
            nickName: rootState.loginUserInfo.nickname,
          },
        }
        if (state.messageExt) {
          const obj = JSON.parse(state.messageExt)

          msgData.ext = JSON.stringify({
            ...msgExt,
            ...obj,
          })
        } else {
          msgData.ext = JSON.stringify(msgExt)
        }
        sendMsg(msgData)
          .then((res) => {
            commit('UPDATE_messageExt', '')
            //console.log('%c Line:138 🍋 res', 'color:#93c0a4', res)
            if (res?.code == 200) {
              // if (params.msgType == 'b_backlist'||params.msgType == 'b_backorder'){
              // }else{
              const msgIdMap = res.data.msgIdMap
              msg.id = msgIdMap[params.msgOptions.id]
              msg.from = EaseChatClient.user
              const msgBody = createMessage.createMsgBody(msg)
              msgBody.type = msgData.senType == 'text' ? 'txt' : 'custom'
              msgBody.customEvent = msgData.senType == 'text' ? '' : msgData.senType
              if (msgData.senType != 'text') {
                msgBody.customExts = {
                  content: msgData.content,
                }
              }
              if (msgData.toUser || (msgData.toGroup && msgData.senType === 'video')) {
                commit('UPDATE_MESSAGE_LIST', msgBody)
              }
              // 提示会话列表更新
              dispatch('gatherConversation', { key: msgBody.to, message: msgBody })
              // 将消息存到本地未读消息列表 只存单聊的
              if (params.msgOptions.chatType == 'singleChat') dispatch('addMsgToUnreadIds', msg.id)
              // }
              commit('SET_INPUT_QUICK_WORD', '')

              resolve('OK')
            } else {
              const errorMessage = res?.msg || '消息发送失败，请重试'
              const error = new Error(errorMessage)
              error.notified = true
              ElMessage.error(errorMessage)
              reject(error)
            }
          })
          .catch((err) => {
            let obj = {
              type: 'error',
              message: err?.msg || err?.message || '消息发送失败，请重试',
            }
            reject(obj)
          })
        // EaseChatClient.send(msg)
        //     .then((res) => {
        //         const { serverMsgId } = res
        //         //console.log('>>>>发送成功demo', res)
        //         msg.id = serverMsgId
        //         msg.from = EaseChatClient.user
        //         const msgBody = createMessage.createMsgBody(msg)
        //         commit('UPDATE_MESSAGE_LIST', msgBody)
        //         // 提示会话列表更新
        //         dispatch('gatherConversation', msgBody.to)
        //         resolve('OK')
        //     })
        //     .catch((error) => {
        //         reject(error)
        //     })
      })
    },
    //添加通知类消息
    createInformMessage: ({ dispatch, commit }, params) => {
      /** 
               const params = {
                    from: '',
                    to: '',
                    chatType: '',
                    msg:''
                }
            */
      const msgBody = _.cloneDeep(params)
      msgBody.type = ALL_MESSAGE_TYPE.INFORM
      const key = setMessageKey(params)
      //console.log('>>>>>>添加系统消息', params)
      commit('UPDATE_MESSAGE_LIST', msgBody)
      dispatch('gatherConversation', { key, message: msgBody })
    },
    //撤回消息
    recallMessage: async ({ dispatch, commit }, params) => {
      // const { mid, to, chatType } = params
      console.log('++++++++', params)

      let { mid, to, chatType } = params

      if (params.chatType == 'singleChat') {
        return new Promise((resolve, reject) => {
          EaseChatClient.recallMessage({ mid, to, chatType })
            .then(() => {
              let sessionId = ''

              const loginUserId = EaseChatClient.user
              if (loginUserId > to) {
                sessionId = loginUserId + to
              } else {
                sessionId = to + loginUserId
              }
              revocationMsg({ messageId: mid, sessionId })
              commit('CHANGE_MESSAGE_BODAY', {
                type: 'recall',
                key: to,
                mid,
              })
              dispatch('gatherConversation', to)
              resolve('OK')
            })
            .catch((error) => {
              reject(error)
            })
        })
      }

      const res = await recallMessage(params)
      if (res?.code != 200) {
        throw new Error(res?.msg || res?.message || '撤回消息失败，请稍后重试')
      }
      return res
      // return new Promise((resolve, reject) => {
      //     EaseChatClient.recallMessage({ mid, to, chatType })
      //         .then(() => {
      //             let sessionId = ''
      //             if (chatType == 'groupChat') {
      //                 sessionId = to
      //             } else {
      //                 const loginUserId = EaseChatClient.user
      //                 if (loginUserId > to) {
      //                     sessionId = loginUserId + to
      //                 } else {
      //                     sessionId = to + loginUserId
      //                 }
      //             }
      //             revocationMsg({ messageId: mid, sessionId })
      //             commit('CHANGE_MESSAGE_BODAY', {
      //                 type: 'recall',
      //                 key: to,
      //                 mid
      //             })
      //             dispatch('gatherConversation', to)
      //             resolve('OK')
      //         })
      //         .catch((error) => {
      //             reject(error)
      //         })
      // })
    },
  },
}
export default Message
